import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "user_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 7A5 5 0 1 1 7 7a5 5 0 0 1 10 0ZM2 18.384c0-.807.43-1.554 1.134-1.97a17.485 17.485 0 0 1 17.732 0A2.288 2.288 0 0 1 22 18.385v1.931c0 .93-.767 1.685-1.713 1.685H3.713C2.767 22 2 21.246 2 20.315v-1.931Z"
    }, null, -1)
  ]))]))
}
export default { render: render }